<template>
    <div>
        <CommonPopupFrame :isOpen="isSelectMatch" :closeCompleteAction="closeSelectMatch">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div style="margin-top: 16px; padding: 0 18px; padding-bottom: 10px; display: flex; align-items: center; justify-content: end; position: relative; border-bottom: 1px solid #f5f5f5">
                <div style="font-weight: 700; position: absolute; left: 50%; transform: translateX(-50%)">경기 형태</div>
                <div @click="closeSelectMatch">
                    <img style="width: 40px" :src="require('@/assets/img/recent_x_btn.png')" alt="" />
                </div>
            </div>
            <div style="padding: 20px; flex: 1;">
                <div style="font-weight: 500;">경기 형태를 선택해주세요</div>
                <div style="display: flex; gap: 20px; margin-bottom: 20px; align-items: center; margin-top: 80px;">
                    <div class="small_play" :class="{ selected: matchType === '5vs5' }" @click="selectMatchType('5vs5')">
                        <img style="width: 100px;" :src="require('@/assets/img/5vs5.png')" alt="">
                        <div style="font-weight: 500; font-size: 14px;">풋살</div>
                    </div>
                    <div class="small_play" :class="{ selected: matchType === '11vs11' }" @click="selectMatchType('11vs11')">
                        <img style="width: 117px;" :src="require('@/assets/img/6vs6.png')" alt="">
                        <div style="font-weight: 500; font-size: 14px;">축구</div>
                    </div>
                </div>
            </div>
            <div @click="setMatchType" class="common_btn">적용하기</div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'

export default {
    name: 'SelectMatchtype',
    components: {CommonPopupFrame},
    props: {
        isSelectMatch: {
            type: Boolean,
            default: false
        },
        closeSelectMatch: {
            type: Function,
            default: () => { }
        },
        selectMatchType: {
            type: Function,
            default: () => { }
        },
        matchType: {
            type: String,
            default: ''
        },
        setMatchType: {
            type: Function,
            default: () => { }
        }
    }
}
</script>

<style scoped>
.small_play {
    flex-basis: 50%;
    box-shadow: 0px 1px 5px 0px #00000040;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 20px 0;
    gap: 20px;
    border-radius: 15px;
}

.selected {
    background-color: #fff3ec;
    transition: 0.3s ease;
}

.common_btn {
    border-radius: 12px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background-color: var(--color-main);
    width: calc(100% - 40px);
    margin: 0 auto;
    margin-top: 12px;
    color: #fff;
    font-weight: 700;
    font-size: 14px;
}
</style>
